<template>
    <div class="main">
        <div class="navmenu">
            <div class="nav-tabs">
                <router-link
                    v-for="item in menuItems"
                    :key="item.id"
                    :to="{ path: item.path, query: navQuery }"
                    class="nav-tab"
                    active-class="is-active"
                >
                    {{ item.name }}
                </router-link>
            </div>
        </div>
        <div class="box">
            <div ref="contentScroll" class="container">
                <router-view :key="$route.fullPath"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TaobaoTabsConfig',
		provide() {
			return {
				retailShop: this,
			}
		},
		data() {
			return {
                menuItems: [
                    { id: 1, name: '淘宝配置', path: '/StoreConfig/taobao/detailed/mSetup' },
                    { id: 2, name: '必选渠道配置(订单匹配)', path: '/StoreConfig/taobao/detailed/channelOrders' },
                    { id: 3, name: '必选渠道配置(库存匹配)', path: '/StoreConfig/taobao/detailed/channelStock' },
                    { id: 4, name: '备选渠道配置(库存匹配)', path: '/StoreConfig/taobao/detailed/backupChannelStock' },
                    { id: 5, name: '宝贝库存数量显示规则设置', path: '/StoreConfig/taobao/detailed/stockDisplayRule' },
                    { id: 6, name: '手工指定-通用规则设置', path: '/StoreConfig/taobao/detailed/manualAssignRule' },
                    { id: 7, name: '一口价选渠道-通用规则设置', path: '/StoreConfig/taobao/detailed/fixedPriceChannelRule' },
                    { id: 8, name: '通用安全库存规则改价格设置', path: '/StoreConfig/taobao/detailed/safetyStockPriceRule' },
                    { id: 9, name: '订单自动匹配渠道规则', path: '/StoreConfig/taobao/detailed/orderAutoMatchRule' },
                    { id: 12, name: '黑名单渠道', path: '/StoreConfig/taobao/detailed/blacklistChannel' },
                ],
				shopId: '',
				shopDetail: null,
				shopDetailLoading: false,
			}
		},
		computed: {
			currentShopId() {
				return this.$route.query.id || sessionStorage.getItem('retailShopId') || ''
			},
			shopName() {
				const detail = this.shopDetail || {}
				return detail.mall_name || detail.shop_name || ''
			},
			navQuery() {
				const id = this.currentShopId
				return id ? { id } : {}
			},
		},
		watch: {
			'$route.path'() {
				this.scrollContentToTop()
			},
			currentShopId: {
				immediate: true,
				handler(id) {
					if (id) {
						this.fetchShopDetail(id)
					}
				},
			},
		},
        methods: {
			scrollContentToTop() {
				this.$nextTick(() => {
					const el = this.$refs.contentScroll
					if (el) {
						el.scrollTop = 0
					}
				})
			},
			fetchShopDetail(id, force) {
				const shopId = String(id)
				if (!shopId) {
					return
				}
				if (!force && this.shopId === shopId && (this.shopDetail || this.shopDetailLoading)) {
					return
				}
				this.shopId = shopId
				this.shopDetailLoading = true
				this.$axios.post('api/retail_shop/detail', { id: shopId }).then(res => {
					if (res.data.code == 0) {
						this.shopDetail = res.data.data || null
						sessionStorage.setItem('retailShopId', shopId)
						sessionStorage.setItem('storeConfigPlatform', 'taobao')
					} else {
						this.$message.error(res.data.message || '获取店铺详情失败')
					}
				}).catch(err => {
					console.log(err)
					this.$message.error('获取店铺详情失败')
				}).finally(() => {
					this.shopDetailLoading = false
				})
			},
        }
    }
</script>

<style scoped lang="less">
    @import './storeTable.less';

    .main {
		width: 100%;
		min-width: 1200px;
		height: calc(100vh - 41px);
		display: flex;
        flex-direction: column;
	}

    .navmenu {
        flex-shrink: 0;
        background-color: #fff;
        border-bottom: 1px solid #eef0f3;
        padding: 8px 16px 10px;

        .nav-tabs {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
        }

        .nav-tab {
            display: inline-flex;
            align-items: center;
            padding: 7px 14px;
            font-size: 13px;
            line-height: 1.4;
            color: #606266;
            text-decoration: none;
            border: 1px solid transparent;
            border-radius: 6px;
            white-space: nowrap;
            transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                color: #303133;
                background-color: #f5f7fa;
            }

            &.is-active {
                color: #ff4714;
                background-color: rgba(255, 71, 20, 0.1);
                border-color: rgba(255, 71, 20, 0.22);
                font-weight: 500;
                box-shadow: 0 1px 2px rgba(255, 71, 20, 0.08);
            }
        }
    }

    .box {
		width: 100%;
		height: 100%;
		padding-top: 8px;
		box-sizing: border-box;
		overflow: hidden;
		.container {
			width: 100%;
			height: 100%;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px 10px 0;
			overflow: auto;

			.container-table-border();

			/deep/ .el-table {
				font-size: 13px;
				color: #303133;

				&::before {
					height: 0;
				}

				thead {
					font-weight: normal;
				}

				th.el-table__cell {
					background: #fafbfc;
					color: #606266;
					font-size: 13px;
					font-weight: normal;
					padding: 10px 0;
				}

				td.el-table__cell {
					font-size: 13px;
					padding: 10px 0;
				}

				.cell {
					line-height: 1.5;
				}

				.el-table__empty-text {
					font-size: 13px;
					color: #909399;
				}

				tr:hover > td.el-table__cell {
					background: #fafbfc !important;
				}
			}

			/deep/ .el-form-item__label {
				font-size: 12px;
				line-height: 36px;
			}

			/deep/ .el-form-item__content {
				font-size: 12px;
			}

			/deep/ .el-input__inner,
			/deep/ .el-textarea__inner,
			/deep/ .el-input-number .el-input__inner {
				height: 36px;
				line-height: 36px;
				font-size: 12px;
			}

			/deep/ .el-input--medium .el-input__inner,
			/deep/ .el-input--small .el-input__inner,
			/deep/ .el-input--mini .el-input__inner {
				height: 36px;
				line-height: 36px;
				font-size: 12px;
			}

			/deep/ .el-select .el-input__inner {
				font-size: 12px;
			}

			/deep/ .el-radio__label,
			/deep/ .el-checkbox__label {
				font-size: 12px;
			}

			/deep/ .field-tip {
				font-size: 11px;
			}

			/deep/ .el-input-number--medium,
			/deep/ .el-input-number--small,
			/deep/ .el-input-number--mini {
				line-height: 34px;

				.el-input__inner {
					height: 36px;
					line-height: 36px;
				}
			}

			/deep/ .el-button {
				padding: 9px 18px;
				font-size: 12px;
			}

			/deep/ .el-button--medium {
				padding: 9px 18px;
				font-size: 12px;
			}
		}

		.bg {
			background-color: #f4f4f4;
			padding: 0px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/taobaoTabsConfig.vue